// import React, { useState, useEffect } from 'react';
// import { useLocation, useNavigate } from 'react-router-dom';
// import "./css/RecipeReg.css";
// import 'bootstrap/dist/css/bootstrap.css';
// import SideNav from './SideNav'
// import TopRootDiv from './TopRootDiv';
// import SherDineNav from './SherDineNav';

// function Recipe() {

// 	const [collapsed, setCollapsed] = useState(false);
// 	const [Recipe_num, setRecipe_num] = useState("");
// 	const [Recipe_Capacity, setRecipe_Capacity] = useState("");
// 	const [Recipe_onlineName, setRecipe_onlineName] = useState("");
// 	const [Recipe_info, setRecipe_info] = useState("");
// 	const [Database, setDatabase] = useState(localStorage.getItem('DB'));
// 	const [imgCode, setImgCode] = useState(localStorage.getItem('imgCode'));
// 	const [company, setCompany] = useState(localStorage.getItem('Company'));
// 	const location = useLocation(null)
// 	const [rows, setRows] = useState([{ category: '', item: '', quantity: '' }]);

// 	const addRow = () => {
// 		setRows([...rows, { category: '', item: '', quantity: '' }]);
// 	};

// 	const removeRow = (index) => {
// 		const newRows = rows.filter((_, rowIndex) => rowIndex !== index);
// 		setRows(newRows);
// 	};
// 	const handleItemChange = (index, event) => {
// 		const { value } = event.target;
// 		const updatedRows = [...rows];
// 		updatedRows[index].item = value;
// 		if (value.length >= 2) {
// 			const xhr = new XMLHttpRequest();
// 			xhr.open('POST', '/getProducts', true);
// 			xhr.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
// 			xhr.onreadystatechange = function () {
// 				if (xhr.readyState === 4) {
// 					if (xhr.status === 200) {
// 						const data = JSON.parse(xhr.responseText);
// 						//(data.products); // Handle or set product suggestions here
// 					} else {
// 						alert('An error occurred while fetching product suggestions.');
// 					}
// 				}
// 			};
// 			xhr.send(JSON.stringify({ term: value }));
// 		}
// 		setRows(updatedRows);
// 	};
// 	const handleQuantityChange = (index, event) => {
// 		const { value } = event.target;
// 		const updatedRows = [...rows];
// 		updatedRows[index].quantity = value;
// 		setRows(updatedRows);
// 	};
// 	const api_base_url = process.env.REACT_APP_API_BASE_URL

// 	const navigate = useNavigate();

// 	const handleCancel = () => {
// 		navigate('/basemenureg', {
// 			state: 'recipeCancel'
// 		})
// 	}

// 	const handleSaveRecipe = async () => {
// 		if (!Recipe_num || !Recipe_Capacity) {
// 			alert("Please fill in all fields.");
// 			return;
// 		}

// 		const data = {
// 			Recipe_num: Recipe_num,
// 			Recipe_Capacity: Recipe_Capacity,
// 			Recipe_onlineName: Recipe_onlineName,
// 			Recipe_info: Recipe_info,
// 		};

// 		try {
// 			//("Try");
// 			const response = await fetch(`${api_base_url}/RecipeReg/${Database}`, {
// 				method: "POST",
// 				headers: {
// 					"Content-Type": "application/json"
// 				},
// 				body: JSON.stringify(data)
// 			});

// 			if (response.ok) {
// 				//("Data submitted successfully");
// 				setRecipe_num("");
// 				setRecipe_Capacity("");
// 				setRecipe_onlineName("");
// 				setRecipe_info("");
// 			} else {
// 				console.error("Failed to submit data");
// 			}
// 		} catch (error) {
// 			console.error("Error:", error);
// 		}
// 	}

// 	const handleRecipe_num = (event) => {
// 		setRecipe_num(event.target.value);
// 	};
// 	const handleRecipe_Capacity = (event) => {
// 		setRecipe_Capacity(event.target.value);
// 	};
// 	const handleRecipe_onlineName = (event) => {
// 		setRecipe_onlineName(event.target.value);
// 	};
// 	const handleRecipe_info = (event) => {
// 		setRecipe_info(event.target.value);
// 	};
// 	const [sideNav, setSideNav] = useState(false)

// 	const handleSideNav = (state) => {
// 		setSideNav(state)
// 	}
// 	const [falseState, setFalseState] = useState(null)

// 	useEffect(() => {
// 		const handleWindowResize = () => {
// 			if (window.innerWidth <= 768) {
// 				setCollapsed(true);
// 			} else {
// 				setCollapsed(false);
// 			}
// 		};

// 		window.addEventListener("resize", handleWindowResize);

// 		return () => {
// 			window.removeEventListener("resize", handleWindowResize);
// 		};
// 	}, []);
// 	return (
// 		<div className='RecipeRegMainDiv'>
// 			<SherDineNav sideNav={(state) => handleSideNav(state)} falseState={falseState} />
// 			<div className='RecipeRegContentDiv'>
// 				<SideNav focus={'Menu'} state={sideNav} falseState={(state) => setFalseState(state)} />
// 				<div className='RecipeRegContentSideBarRight'>
// 					<div className="RecipeRegSidebar">
// 						<TopRootDiv image={'Menu Management'} root={['Menu Management', 'Base Menu']} section={'Add Recipe'} />
// 					</div>
// 					<div className='Container_Menu RecipeRegForm'>
// 						<div className='RecipeAreaReg_areaDetails_span'>
// 							<span> Add Recipe</span>
// 							<div className=' AddItem_Buttons AddItem_Buttons_RecipeAreaReg'>
// 								<button className='btn_cancel btn_cancel_RecipeAreaReg' onClick={handleCancel}>Cancel</button>
// 								<button className='btn_Save btn_Savel_RecipeAreaReg' onClick={handleSaveRecipe}>Save & Changes</button>
// 							</div>
// 						</div>
// 						<div className='RecipeRegForm_part'>
// 							<div className='RecipeRegForm_part_spanInput'>
// 								<span>Select An Item</span>
// 								<input className="CategoryName" type="text" value={Recipe_num} onChange={handleRecipe_num} />
// 							</div>
// 						</div>
// 						<div>
// 							<table>
// 								<thead>
// 								</thead>
// 								<tbody>
// 									{rows.map((row, index) => (
// 										<tr key={index}>
// 											<td>
// 												<input type="hidden" name="category[]" value={row.category} />
// 												<input
// 													type="text"
// 													name="item[]"
// 													value={row.item}
// 													onChange={(e) => handleItemChange(index, e)}
// 													className="product-input"
// 													autoComplete="on"
// 												/>
// 											</td>
// 											<td>
// 												<input
// 													type="text"
// 													name="quantity[]"
// 													value={row.quantity}
// 													onChange={(e) => handleQuantityChange(index, e)}
// 												/>
// 											</td>
// 											<td>
// 												<button
// 													type="button"
// 													className="btn btn-outline-danger btn-sm remove-item"
// 													onClick={() => removeRow(index)}
// 												>
// 													Remove
// 												</button>
// 											</td>
// 										</tr>
// 									))}
// 								</tbody>
// 							</table>
// 							<button type="button" className="add-item" onClick={addRow}>
// 								Add Item
// 							</button>
// 						</div>
// 					</div>

// 				</div>
// 			</div>
// 		</div>
// 	)
// }
// export default Recipe
//currently working 05-11-24 11:33am

// import React, { useState, useEffect } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import "./css/RecipeReg.css";
// import "bootstrap/dist/css/bootstrap.css";
// import SideNav from "./SideNav";
// import TopRootDiv from "./TopRootDiv";
// import SherDineNav from "./SherDineNav";

// function Recipe() {
// 	const [collapsed, setCollapsed] = useState(false);
// 	const [Recipe_num, setRecipe_num] = useState("");
// 	const [Recipe_Capacity, setRecipe_Capacity] = useState("");
// 	const [Recipe_onlineName, setRecipe_onlineName] = useState("");
// 	const [Recipe_info, setRecipe_info] = useState("");
// 	const [Database, setDatabase] = useState(localStorage.getItem("DB"));
// 	const [imgCode, setImgCode] = useState(localStorage.getItem("imgCode"));
// 	const [company, setCompany] = useState(localStorage.getItem("Company"));
// 	const [rows, setRows] = useState([{ category: "", item: "", quantity: "" }]);
// 	const [products, setProducts] = useState([]); // For product list
// 	const [selectedProduct, setSelectedProduct] = useState(""); // For dropdown selection
// 	const api_base_url = process.env.REACT_APP_API_BASE_URL

// 	const navigate = useNavigate();

// 	// useEffect(() => {
// 	// 	// Fetch products on component load
// 	// 	const fetchProducts = () => {
// 	// 		const xhr = new XMLHttpRequest();
// 	// 		xhr.open("GET", "/GetItemReg", true);
// 	// 		xhr.onreadystatechange = function () {
// 	// 			if (xhr.readyState === 4 && xhr.status === 200) {
// 	// 				const data = JSON.parse(xhr.responseText);
// 	// 				setProducts(data.products);
// 	// 			}
// 	// 		};
// 	// 		xhr.send();
// 	// 	};
// 	// 	fetchProducts();
// 	// }, []);

// 	const addRow = () => {
// 		if (selectedProduct) {
// 			setRows([...rows, { category: "", item: selectedProduct, quantity: "" }]);
// 		}
// 	};

// 	const removeRow = (index) => {
// 		const newRows = rows.filter((_, rowIndex) => rowIndex !== index);
// 		setRows(newRows);
// 	};

// 	const handleQuantityChange = (index, event) => {
// 		const { value } = event.target;
// 		const updatedRows = [...rows];
// 		updatedRows[index].quantity = value;
// 		setRows(updatedRows);
// 	};

// 	const handleCancel = () => {
// 		navigate("/basemenureg", { state: "recipeCancel" });
// 	};

// 	const handleSaveRecipe = async () => {
// 		if (!Recipe_num || !Recipe_Capacity) {
// 			alert("Please fill in all fields.");
// 			return;
// 		}

// 		const data = {
// 			Recipe_num,
// 			Recipe_Capacity,
// 			Recipe_onlineName,
// 			Recipe_info,
// 		};

// 		try {
// 			const response = await fetch(
// 				`${process.env.REACT_APP_API_BASE_URL}/GetItemReg/${Database}`,
// 				{
// 					method: "POST",
// 					headers: {
// 						"Content-Type": "application/json",
// 					},
// 					body: JSON.stringify(data),
// 				}
// 			);

// 			if (response.ok) {
// 				//("Data submitted successfully");
// 				// setRecipe_num("");
// 				// setRecipe_Capacity("");
// 				// setRecipe_onlineName("");
// 				// setRecipe_info("");
// 			} else {
// 				console.error("Failed to submit data");
// 			}
// 		} catch (error) {
// 			console.error("Error:", error);
// 		}
// 	};
// 	// useEffect(() => {
// 	//     // Fetch categories from the backend
// 	//     fetch(`${api_base_url}/GetItemReg/${Database}`)
// 	//         .then((response) => response.json())
// 	//         .then((ProData) => {
// 	//             //(ProData); 
// 	//             setSelectedProduct(ProData); 
// 	//         })
// 	//         .catch((error) => console.error("Error fetching categories:", error));
// 	// }, []);
// 	// useEffect(() => {
// 	// 	// Fetch categories from the backend
// 	// 	fetch(`${api_base_url}/GetItemReg/${Database}`)
// 	// 		.then((response) => response.json())
// 	// 		.then((ProData) => {
// 	// 			if (ProData ==='' ) {
// 	// 				setProducts('No Data Found in Database')
// 	// 			}
// 	// 			else {
// 	// 			//(ProData);
// 	// 			setProducts(ProData); 
// 	// 			}
// 	// 		})
// 	// 		.catch((error) => console.error("Error fetching categories:", error));
// 	// }, []);
// 	useEffect(() => {
// 		// Fetch categories from the backend
// 		fetch(`${api_base_url}/GetItemReg/${Database}`)
// 			.then((response) => response.json())
// 			.then((ProData) => {
// 				if (ProData.length === 0) {
// 					setProducts([]); // Set as empty array if no data is found
// 				} else {
// 					setProducts(ProData); // Set products data
// 				}
// 			})
// 			.catch((error) => console.error("Error fetching categories:", error));
// 	}, []);
// 	return (
// 		<div className="RecipeRegMainDiv">
// 			<SherDineNav sideNav={setCollapsed} />
// 			<div className="RecipeRegContentDiv flex gap-3">
// 				<SideNav focus={"Menu"} state={collapsed} />
// 				<div className="RecipeRegContentSideBarRight">
// 					<TopRootDiv
// 						image={"Menu Management"}
// 						root={["Menu Management", "Base Menu"]}
// 						section={"Add Recipe"}
// 					/>
// 					<div className="Container_Menu RecipeRegForm">
// 						<div className="RecipeAreaReg_areaDetails_span">
// 							<span>Add Recipe</span>
// 							<div className="AddItem_Buttons AddItem_Buttons_RecipeAreaReg">
// 								<button
// 									className="btn_cancel btn_cancel_RecipeAreaReg"
// 									onClick={handleCancel}
// 								>
// 									Cancel
// 								</button>
// 								<button
// 									className="btn_Save btn_Savel_RecipeAreaReg"
// 									onClick={handleSaveRecipe}
// 								>
// 									Save & Changes
// 								</button>
// 							</div>
// 						</div>
// 						{/* <div className="RecipeRegForm_part">
// 							<div className="RecipeRegForm_part_spanInput">
// 								<span>Select An Item</span>
// 								<select
// 									className="CategoryName"
// 									value={selectedProduct}
// 									onChange={(e) => setSelectedProduct(e.target.value)}
// 								>
// 									<option value="">Select a product</option>
// 									{products.map((product, index) => (
// 										<option key={index} value={product.productName}>
// 											{product.productName}
// 										</option>
// 									))}
// 								</select>
// 							</div>
// 						</div> */}
// 						{/* <div className="RecipeRegForm_part">
// 							<div className="RecipeRegForm_part_spanInput">
// 								<span>Select An Item</span>
// 								<select
// 									className="CategoryName"
// 									value={selectedProduct}
// 									onChange={(e) => setSelectedProduct(e.target.value)}
// 								>
// 									{products.map((product, index) => (
// 										<option key={index} value={product.productName}>
// 											{product.productName}
// 										</option>
// 									))}
// 								</select>
// 							</div>
// 						</div> */}
// 						<div className="RecipeRegForm_part">
// 							<div className="RecipeRegForm_part_spanInput">
// 								<span>Select An Item</span>
// 								<select
// 									className="CategoryName"
// 									value={selectedProduct}
// 									onChange={(e) => setSelectedProduct(e.target.value)}
// 								>
// 									{products.length === 0 ? (
// 										<option value="">No Data Found</option>
// 									) : (
// 										<>
// 											{products.map((product, index) => (
// 												<option key={index} value={product.productName}>
// 													{product.productName}
// 												</option>
// 											))}
// 										</>
// 									)}
// 								</select>
// 							</div>
// 						</div>
// 						<div>
// 							<table>
// 								<thead></thead>
// 								<tbody>
// 									{rows.map((row, index) => (
// 										<tr key={index}>
// 											<td>
// 												<input
// 													type="hidden"
// 													name="category[]"
// 													value={row.category}
// 												/>
// 												<input
// 													type="text"
// 													name="item[]"
// 													value={row.item}
// 													readOnly
// 													className="product-input"
// 												/>
// 											</td>
// 											<td>
// 												<input
// 													type="text"
// 													name="quantity[]"
// 													value={row.quantity}
// 													onChange={(e) => handleQuantityChange(index, e)}
// 												/>
// 											</td>
// 											<td>
// 												<button
// 													type="button"
// 													className="btn btn-outline-danger btn-sm remove-item"
// 													onClick={() => removeRow(index)}
// 												>
// 													Remove
// 												</button>
// 											</td>
// 										</tr>
// 									))}
// 								</tbody>
// 							</table>
// 							<button
// 								type="button"
// 								className="add-item"
// 								onClick={addRow}
// 								disabled={!selectedProduct} // Disable until a product is selected
// 							>
// 								Add Item
// 							</button>
// 						</div>
// 					</div>
// 				</div>
// 			</div>
// 		</div>
// 	);
// }

// export default Recipe;

// import React, { useState, useEffect } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import "./css/AddRecipe.css";
// import "bootstrap/dist/css/bootstrap.css";
// import "./css/tableAreaReg.css"
// import SideNav from "./SideNav";
// import TopRootDiv from "./TopRootDiv";
// import SherDineNav from "./SherDineNav";

// function AddRecipe() {
// 	const [collapsed, setCollapsed] = useState(false);
// 	const [Recipe_num, setRecipe_num] = useState("");
// 	const [Recipe_Capacity, setRecipe_Capacity] = useState("");
// 	const [Recipe_onlineName, setRecipe_onlineName] = useState("");
// 	const [Recipe_info, setRecipe_info] = useState("");
// 	const [Database, setDatabase] = useState(localStorage.getItem("DB"));
// 	const [imgCode, setImgCode] = useState(localStorage.getItem("imgCode"));
// 	const [company, setCompany] = useState(localStorage.getItem("Company"));
// 	const [rows, setRows] = useState([{ category: "", item: "", quantity: "" }]);
// 	const [products, setProducts] = useState([]);
// 	const [selectedProduct, setSelectedProduct] = useState("");
	
// 	const api_base_url = process.env.REACT_APP_API_BASE_URL;
// 	// const [products, setProducts] = useState([]);
// 	const [filteredProducts, setFilteredProducts] = useState([]);
// 	// const [selectedProduct, setSelectedProduct] = useState("");
// 	const [showDropdown, setShowDropdown] = useState(false);
// 	const navigate = useNavigate();

// 	const addRow = () => {
// 		if (selectedProduct) {
// 			setRows([...rows, { category: "", item: selectedProduct, quantity: "" }]);
// 		}
// 	};
// 	const handleInputChange = (e) => {
// 		const value = e.target.value;
// 		setSelectedProduct(value);
// 		// Filter products based on input
// 		const filtered = products.filter((product) =>
// 			product.productName.toLowerCase().includes(value.toLowerCase())
// 		);
// 		setFilteredProducts(filtered);
// 		setShowDropdown(true); // Show dropdown when typing
// 	};
// 	const handleSeachInput = {
		
// 	}
// 	const handleSelectProduct = (productName) => {
// 		setSelectedProduct(productName);
// 		setShowDropdown(false); // Hide dropdown after selecting
// 	};
// 	const removeRow = (index) => {
// 		const newRows = rows.filter((_, rowIndex) => rowIndex !== index);
// 		setRows(newRows);
// 	};

// 	const handleQuantityChange = (index, event) => {
// 		const { value } = event.target;
// 		const updatedRows = [...rows];
// 		updatedRows[index].quantity = value;
// 		setRows(updatedRows);
// 	};

// 	const handleCancel = () => {
// 		navigate("/Inventory", { state: "recipeCancel" });
// 	};

// 	const handleSaveRecipe = async () => {
// 		if (!Recipe_num || !Recipe_Capacity) {
// 			alert("Please fill in all fields.");
// 			return;
// 		}

// 		const data = {
// 			Recipe_num,
// 			Recipe_Capacity,
// 			Recipe_onlineName,
// 			Recipe_info,
// 		};

// 		try {
// 			const response = await fetch(
// 				`${api_base_url}/GetItemReg/${Database}`,
// 				{
// 					method: "POST",
// 					headers: {
// 						"Content-Type": "application/json",
// 					},
// 					body: JSON.stringify(data),
// 				}
// 			);

// 			if (response.ok) {
// 				//("Data submitted successfully");
// 			} else {
// 				console.error("Failed to submit data");
// 			}
// 		} catch (error) {
// 			console.error("Error:", error);
// 		}
// 	};

// 	useEffect(() => {
// 		fetch(`${api_base_url}/GetItemReg/${Database}`)
// 			.then((response) => response.json())
// 			.then((ProData) => {
// 				if (ProData.length === 0) {
// 					setProducts([]);
// 				} else {
// 					setProducts(ProData);
// 				}
// 			})
// 			.catch((error) => console.error("Error fetching categories:", error));
// 	}, []);

// 	return (
// 		<div className="RecipeRegMainDiv">
// 			<SherDineNav sideNav={setCollapsed} />
// 			<div className="RecipeRegContentDiv flex gap-3">
// 				<SideNav focus={"Menu"} state={collapsed} />
// 				<div className="RecipeRegContentSideBarRight">
// 					<TopRootDiv
// 						image={"Menu Management"}
// 						root={["Menu Management", "Base Menu"]}
// 						section={"Add Recipe"}
// 					/>
// 					<div className="Container_Menu RecipeRegForm">

// 						{/* <div className="RecipeAreaReg_areaDetails_span">
							
// 						</div> */}
// 						<div className='RecipeAddReg_areaDetails_span'>
// 							{/* <span>Category Details</span> */}
// 							<div className="RecipeRegForm_part_spanInput">
								
// 								<div className="ProductDropdownRecipe">
// 									<input
// 										type="text"
// 										className="CategoryNameRecipe"
// 										value={selectedProduct}
// 										onChange={handleInputChange}
// 										onFocus={() => setShowDropdown(true)} // Show dropdown on focus
// 										placeholder="Type to search..."
// 									/>
// 									{showDropdown && filteredProducts.length > 0 && (
// 										<div className="DropdownList">
// 											{filteredProducts.map((product, index) => (
// 												<div
// 													key={index}
// 													className="DropdownItem"
// 													onClick={() => handleSelectProduct(product.productName)}
// 												>
// 													{product.productName}
// 												</div>
// 											))}
// 										</div>
// 									)}
// 								</div>
// 								<button className='CategoryNameSearchInput' onClick={handleSeachInput}>Search</button>
// 							</div>
// 							<div className=' AddItem_Buttons AddItem_Buttons_CategoryAreaReg AddItems_Buttons'>
// 								<button className='btn_cancel btn_cancel_CategoryAreaReg' onClick={handleCancel}>Cancel</button>
// 								<button className='btn_Save btn_Savel_CategoryAreaReg' onClick={handleSaveRecipe}>Save</button>
// 							</div>
// 						</div>
// 						<div className="RecipeRegForm_part">

// 							<div className="AddItem_ButtonsReci AddItem_Buttons_RecipeAreaReg">
								
// 								<input type="text" className="SelectedItemInputBox" />
// 							</div>


// 							<table className="table">
// 								<thead>
// 									<tr>
// 										<th>Item</th>
// 										<th>Quantity</th>
// 										<th>Action</th>
// 									</tr>
// 								</thead>
// 								<tbody>
// 									{rows.map((row, index) => (
// 										<tr key={index}>
// 											<td>
// 												<input
// 													type="text"
// 													name="item[]"
// 													value={row.item}
// 													readOnly
// 													className="product-input"
// 												/>
// 											</td>
// 											<td>
// 												<input
// 													type="text"
// 													name="quantity[]"
// 													value={row.quantity}
// 													onChange={(e) => handleQuantityChange(index, e)}
// 												/>
// 											</td>
// 											<td>
// 												<button
// 													type="button"
// 													className="btn btn-outline-danger btn-sm remove-item"
// 													onClick={() => removeRow(index)}
// 												>
// 													Remove
// 												</button>
// 											</td>
// 										</tr>
// 									))}
// 								</tbody>
// 							</table>
// 						</div>
// 						<button
// 							type="button"
// 							className="add-item"
// 							onClick={addRow}
// 							disabled={!selectedProduct}
// 						>
// 							Add Item
// 						</button>
// 					</div>
// 				</div>
// 			</div>
// 		</div>
// 	);
// }

// export default AddRecipe;

import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./css/AddRecipe.css";
import "bootstrap/dist/css/bootstrap.css";
import "./css/tableAreaReg.css"
import SideNav from "./SideNav";
import TopRootDiv from "./TopRootDiv";
import SherDineNav from "./SherDineNav";
import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios'
import Select, { components } from 'react-select';



function AddRecipe() {
	const [collapsed, setCollapsed] = useState(false);
	const [Recipe_num, setRecipe_num] = useState("");
	const [Recipe_Capacity, setRecipe_Capacity] = useState("");
	const [Recipe_onlineName, setRecipe_onlineName] = useState("");
	const [Recipe_info, setRecipe_info] = useState("");
	const [Database, setDatabase] = useState(localStorage.getItem("DB"));
	const [imgCode, setImgCode] = useState(localStorage.getItem("imgCode"));
	const [company, setCompany] = useState(localStorage.getItem("Company"));
	const [rows, setRows] = useState([{ category: "", item: "", quantity: "" }]);
	const [products, setProducts] = useState([]);
	const [selectedProduct, setSelectedProduct] = useState("");
	const [displayedProduct, setDisplayedProduct] = useState(""); // New state for displaying only on search/enter
	const [message, setMessage] = useState("");
	const api_base_url = process.env.REACT_APP_API_BASE_URL;
	const [filteredProducts, setFilteredProducts] = useState([]);
	const [showDropdown, setShowDropdown] = useState(false);
	const [highlightedIndex, setHighlightedIndex] = useState(-1); // For keyboard navigation
	const navigate = useNavigate();

	const addRow = () => {
		// if (selectedProduct) {
			setRows([...rows, { item: "selectedProduct", quantity: "", Unit: "", Area:"", Action:""}]);
		// }
	};

	const handleInputChange = (e) => {
		const value = e.target.value;
		setSelectedProduct(value);
		
		// Filter products based on multiple-word input
		const filtered = products.filter((product) =>
			product.productName.toLowerCase().includes(value.toLowerCase())
		);
		setFilteredProducts(filtered);
		setShowDropdown(true);
		setHighlightedIndex(-1); // Reset the highlighted index on new input
	};

	const handleSelectProduct = (productName) => {
		setSelectedProduct(productName);
		setShowDropdown(false); // Hide dropdown after selecting
	};

	const handleKeyDown = (e) => {
		if (showDropdown) {
			if (e.key === "ArrowDown") {
				// Move selection down
				setHighlightedIndex((prev) => (prev < filteredProducts.length - 1 ? prev + 1 : 0));
			} else if (e.key === "ArrowUp") {
				// Move selection up
				setHighlightedIndex((prev) => (prev > 0 ? prev - 1 : filteredProducts.length - 1));
			} else if (e.key === "Enter" && highlightedIndex >= 0) {
				// Select the highlighted product
				handleSearchInput();
				handleSelectProduct(filteredProducts[highlightedIndex].productName);
			} else if (e.key === "Escape") {
				// Hide dropdown on Escape
				setShowDropdown(false);
			}
		}
	};

	const handleSearch = () => {
		handleSelectProduct(selectedProduct);
	};

	const removeRow = (index) => {
		const newRows = rows.filter((_, rowIndex) => rowIndex !== index);
		setRows(newRows);
	};

	const handleQuantityChange = (index, event) => {
		const { value } = event.target;
		const updatedRows = [...rows];
		updatedRows[index].quantity = value;
		setRows(updatedRows);
	};

	const handleUnitChange = (index, event) => {
		const { value } = event.target;
		const updatedRows = [...rows];
		updatedRows[index].quantity = value;
		setRows(updatedRows);
	};

	const handleAreaChange = (index, event) => {
		const { value } = event.target;
		const updatedRows = [...rows];
		updatedRows[index].quantity = value;
		setRows(updatedRows);
	};


	const handleCancel = () => {
		navigate("/Inventory", { state: "recipeCancel" });
	};

	const handleSaveRecipe = async () => {
		if (!Recipe_num || !Recipe_Capacity) {
			alert("Please fill in all fields.");
			return;
		}

		const data = {
			Recipe_num,
			Recipe_Capacity,
			Recipe_onlineName,
			Recipe_info,
		};

		try {
			const response = await fetch(
				`${api_base_url}/GetItemReg/${Database}`,
				{
					method: "POST",
					headers: {
						"Content-Type": "application/json",
					},
					body: JSON.stringify(data),
				}
			);

			if (response.ok) {
				//("Data submitted successfully");
			} else {
				console.error("Failed to submit data");
			}
		} catch (error) {
			console.error("Error:", error);
		}
	};
	// const handleSearchInput = () => {
	// 	setDisplayedProduct(selectedProduct); // Display the selected item when search button is clicked
	// 	setShowDropdown(false);
	// };
	const handleSearchInput = () => {
		const productExists = filteredProducts.some(
			(product) => product.productName.toLowerCase() === selectedProduct.toLowerCase() // product.productName === selectedProduct
		);

		if (productExists) {
			setDisplayedProduct(selectedProduct);
		} else {
			toast.error("Not registered");
			setDisplayedProduct("");
		}
	};

	useEffect(() => {
		fetch(`${api_base_url}/GetItemReg/${Database}`,)
		.then((response) => {
			if (response.ok) return response.json();
			throw new Error("Unauthorized or failed to fetch data");
		})
		.then((ProData) => {
			setProducts(ProData.length > 0 ? ProData : []);
		})
		.catch((error) => console.error("Error fetching items:", error));
	}, [api_base_url]);

	// axios.defaults.withCredentials = true

	// useEffect(() => {
	// 	axios.get(`${api_base_url}/GetItemReg`)
	// 	.then((response) => {
	// 		// Handle successful response
	// 		const ProData = response.data;
	// 		setProducts(ProData.length > 0 ? ProData : []);
	// 	})
	// 	.catch((error) => {
	// 		// Handle error
	// 		console.error("Error fetching items:", error);
	// 	});
	// }, [api_base_url]);

	const options = [
		{ value: '1', label: 'person' },
		{ value: '2', label: 'sadasd' },
	];

	const handleGetProducts = () => {
		try {
			
		} catch (error) {
			
		}
	}

	useEffect(() => {
		handleGetProducts()
	},[])

	const [selectedOption,setSelectedOption] = useState(null)

	const customStyles = {
		option: (provided, state) => ({
			...provided,
			fontSize: '.8em',
			// fontFamily: 'Poppins',
			textAlign: 'left',
			backgroundColor: state.isSelected ? '#c8cbcf' : '#FFF',
			color: state.isFocused ? '#000' : '#000',
			cursor: 'pointer', // Add cursor pointer on hover
			':hover': {
				backgroundColor: '#c8cbcf',
				color: '#000',
			},
			':active': {
				...provided[':active'],
				backgroundColor: '#c8cbcf'
			}
		}),
		control: (provided, state) => ({
			...provided,
			width: '100%',
			// height: '2.5rem',
			minHeight: '2rem',
			fontSize: '.9em',
			borderRadius: '.1rem', // Adjust this value as needed
			padding: '0', // Ensure no extra padding is added
			// border: 'none',
			fontWeight: '500',
			// color: 'white !important', // Set text color to white
			backgroundColor: 'transparent', // Change this to 'transparent' for a clear background
			boxShadow: 'none', // Remove the blue focus shadow
			border: selectedOption ? 'none' : '1px solid #ccc', // Optional: add custom border on focus
			borderBottom: selectedOption ? '1px solid #ccc' : '1px solid #ccc',
			'&:hover': {
				borderBottom: '1px solid #c8cbcf', // Optional: border on hover
			}
			// border: state.selectValue ? '1px solid #ccc' : 'none', // Apply full border if no selected option
			// borderBottom: state.selectValue ? '2px solid #c8cbcf' : '1px solid #ccc', // Apply bottom border when option is selected
			// '&:hover': {
			// 	border: state.selectValue ? '1px solid #ccc' : 'none', // Apply full border on hover if no option selected
			// 	borderBottom: state.selectValue ? '2px solid #c8cbcf' : 'none', // Apply bottom border on hover
			// }
		}),
		valueContainer: (provided) => ({
		  ...provided,
		  height: '2.25rem',
		  minHeight: '2rem',
		  padding: '0 8px', // Center the text vertically
		  display: 'flex',
		//   color: '#fff',
		  alignItems: 'center',
		  fontSize: '.9rem'
		}),
		input: (provided) => ({
		  ...provided,
		  height: '2.25rem',
		  minHeight: '2rem',
		  margin: '0', 
		  padding: '0',
		//   color: '#fff',
		  fontSize: '.9rem' 
		}),
		indicatorsContainer: (provided) => ({
		  ...provided,
		  height: '2.25rem',
		  display: 'flex',
		  alignItems: 'center',
		  padding:'.5rem',
		  paddingTop: '0',
		  paddingBottom: '0'
		}),
		dropdownIndicator: (provided) => ({
		  ...provided,
		  padding: '0', // Remove padding to center the icon
		  width: '1rem',
		  marginLeft: '.5rem',
		//   color: '#fff',
		  cursor: 'pointer',
		}),
		placeholder: (provided) => ({
		  ...provided,
		  margin: '0',
		  fontSize: '.95em',
		//   color: '#fff',
		//   fontFamily: 'poppins'
	    }),
		menu: (provided) => ({
		  ...provided,
		  borderRadius: '.1rem', // Adjust this value as needed
		}),
		singleValue: (provided) => ({
			...provided,
			// color: 'white', // Set selected option text color to white
		}),
	};

    const handleChange = (option) => {
        setSelectedOption(option)
    }

	const [subRecipe,setSubRecipe] = useState(false)
	const handleSubRecipe = (e) => {
		e.stopPropagation()
		setSubRecipe(a => !a)
	}
	
	

	return (
		<div className="RecipeRegMainDiv">
			<SherDineNav sideNav={setCollapsed} />
			<div className="RecipeRegContentDiv flex gap-3">
				<SideNav focus={"Inventory"} state={collapsed} />
				<div className="RecipeRegContentSideBarRight">
					<TopRootDiv
						image={"Inventory"}
						root={["Inventory","Recipe Management"]}
						section={"Add Recipe"}
					/>
					<div className="Container_Menu RecipeRegForm pb-0">
						<div className=" w-full h-full overflow-auto">
							<div className=" rounded-sm w-full h-max gap-3 flex flex-col">
								<div className="w-1/3">
									<Select
										styles={customStyles}
										placeholder='Guests'
										value={selectedOption}
										options={options}
										onChange={(selectedOption) => handleChange(selectedOption)}
										// components={{ 
										// 	Option: CustomOption,
										// 	SingleValue: CustomSingleValue, 
										// 	Placeholder: CustomPlaceholder
										// }}
										// isDisabled={true}
										/>
								</div>
								<div className="w-full h-max flex flex-col text-left borderColorCommon rounded-sm">
									<div className="h-max flex p-3">
										<div className="w-1/2">Pizza [large]</div>
										<div className="w-1/2 flex justify-end items-center"><button>Save</button></div>
									</div>
									<div className="h-full p-3 border-t border-t-[#aaa]">
										<div className="borderColorCommon rounded-sm flex flex-col">
											<div className="h-max p-3">
												Recipe for Pizza [large]
											</div>
											<div className="h-full border-t border-t-[#aaa] p-3 flex flex-col gap-3">
												<div className="flex flex-col gap-3">
													<div className="h-full w-full">
														<div className="w-full">
															<table className="w-full">
																<thead>
																	<tr>
																		<th>Item</th>
																		<th>Quantity</th>
																		<th>Unit</th>
																		<th>Area</th>
																		<th>Action</th>
																	</tr>
																</thead>
																<tbody>
																	{rows.map((row, index) => (
																		<tr key={index}>
																			<td>
																				<input
																					type="text"
																					name="item[]"
																					// value={row.item}
																					className="product-input"
																				/>
																			</td>
																			<td>
																				<input
																					type="text"
																					name="quantity[]"
																					// value={row.quantity}
																					onChange={(e) => handleQuantityChange(index, e)}
																				/>
																			</td>
																			<td>
																				<input
																					type="text"
																					name="unit"
																					// value="{unit}"
																					onChange={(e) => handleUnitChange(index, e)}
																				/>
																			</td>
																			<td>
																				<input 
																					type="text" 
																					name="Area[]"
																					// value="{row.Area}"
																					onChange={(e) => handleAreaChange(index, e)}
																				/>
																			</td>
																			<td>
																				<button
																					type="button"
																					className="btn btn-outline-danger btn-sm remove-item"
																					onClick={() => removeRow(index)}
																				>
																					Remove
																				</button>
																			</td>
																		</tr>
																	))}
																</tbody>
															</table>
														</div>
													</div>
													<div className="h-max border-t pr-0 pl-3 pt-3 pb-3 border-t-[#aaa] flex justify-end items-center">
														<button type="button"
															className="rounded-2xl border p-2 font-[600] shadow-md"
															onClick={addRow}
															// disabled={!displayedProduct}
														>
															Add new raw material
														</button>
													</div>
												</div>
												<div className="borderColorCommon rounded-sm flex flex-col h-max">
													<div className="h-max p-3 pr-0 flex w-full cursor-pointer" onClick={handleSubRecipe}>
														<div className="w-1/2 flex justify-start items-center">asdasd</div>
														<div className="w-1/2 flex justify-end items-center">a<img src="" alt="" /></div>
													</div>
													{
														subRecipe && (
															<div className="p-3 flex flex-col border-t border-t-[#aaa]">
																<div className="w-full">
																	<table className="w-full">
																		<thead>
																			<tr>
																				<th>Item</th>
																				<th>Quantity</th>
																				<th>Unit</th>
																				<th>Area</th>
																				<th>Action</th>
																			</tr>
																		</thead>
																		<tbody>
																			{rows.map((row, index) => (
																				<tr key={index}>
																					<td>
																						<input
																							type="text"
																							name="item[]"
																							// value={row.item}
																							className="product-input"
																						/>
																					</td>
																					<td>
																						<input
																							type="text"
																							name="quantity[]"
																							// value={row.quantity}
																							onChange={(e) => handleQuantityChange(index, e)}
																						/>
																					</td>
																					<td>
																						<input
																							type="text"
																							name="unit"
																							// value="{unit}"
																							onChange={(e) => handleUnitChange(index, e)}
																						/>
																					</td>
																					<td>
																						<input 
																							type="text" 
																							name="Area[]"
																							// value="{row.Area}"
																							onChange={(e) => handleAreaChange(index, e)}
																						/>
																					</td>
																					<td>
																						<button
																							type="button"
																							className="btn btn-outline-danger btn-sm remove-item"
																							onClick={() => removeRow(index)}
																						>
																							Remove
																						</button>
																					</td>
																				</tr>
																			))}
																		</tbody>
																	</table>
																</div>
																<div className="h-max border-t pr-0 pl-3 pt-3 pb-3 border-t-[#aaa] flex justify-end items-center">
																	<button type="button"
																		className="rounded-2xl border p-2 font-[600] shadow-md"
																		onClick={addRow}
																		// disabled={!displayedProduct}
																	>
																		Add new raw material
																	</button>
																</div>
															</div>
														)
													}
												</div>
											</div>
										</div>
									</div>
									<div className="h-max flex justify-end items-center p-3 border-t border-t-[#aaa]"><button>Save</button></div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
export default AddRecipe;
